var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.667 469.333H304.64l154.88-186.026a42.667 42.667 0 1 0-65.707-54.614l-213.333 256a50.773 50.773 0 0 0-3.84 6.4c0 2.134 0 3.414-2.987 5.547a42.667 42.667 0 0 0-2.986 15.36 42.667 42.667 0 0 0 2.986 15.36c0 2.133 0 3.413 2.987 5.547a50.773 50.773 0 0 0 3.84 6.4l213.333 256a42.667 42.667 0 0 0 32.854 15.36 42.667 42.667 0 0 0 27.306-9.814 42.667 42.667 0 0 0 5.547-60.16L304.64 554.667h506.027a42.667 42.667 0 0 0 0-85.334z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.886baf1364b6c7e992c046c13a0dd60f.svg";
export { ForwardRef as ReactComponent };